const DEFAULT_FORBIDDEN_SYMBOLS = '}{:\\[\\]",';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class ValidateHelper {
  public static email(input: string): boolean {
    const pattern
      // eslint-disable-next-line no-control-regex
      = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|[\x01-\x09\x0B\x0C\x0E-\x7F])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21-\x5A\x53-\x7F]|\\[\x01-\x09\x0B\x0C\x0E-\x7F])+)\])$/i;
    return input ? pattern.test(input.trim()) : false;
  }

  public static phone(input: string): boolean {
    const pattern
      = /^((\+7) ?)?[ -]?((\(\d{3}\))|(\d{3}))?([ -])?(\d{3}[- ]?\d{2}[- ]?\d{2})$/;

    return input ? pattern.test(input.trim()) : false;
  }

  public static phoneCode(phoneNumber: string): boolean {
    if (!phoneNumber) {
      return false;
    }
    const number = phoneNumber.trim().replace(/\D/g, '');

    if (!number) {
      return false;
    }

    const code = Number(number.slice(1, 4));

    if (!code) {
      return false;
    }
    const mobileCodes = [900, 901, 902, 903, 904, 905, 906, 908, 909, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 930, 931, 932, 933, 934, 936, 937, 938, 939, 941, 942, 949, 950, 951, 952, 953, 954, 955, 956, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 977, 978, 979, 980, 981, 982, 983, 984, 985, 986, 987, 988, 989, 990, 991, 992, 993, 994, 995, 996, 997, 999];

    const regionCodes = [301, 302, 336, 341, 342, 343, 345, 346, 347, 349, 351, 352, 353, 365, 381, 382, 383, 384, 385, 388, 390, 391, 394, 395, 401, 411, 413, 415, 416, 421, 423, 424, 426, 427, 471, 472, 473, 474, 475, 481, 482, 483, 484, 485, 486, 487, 491, 492, 493, 494, 495, 496, 498, 499, 811, 812, 813, 814, 815, 816, 817, 818, 820, 821, 831, 833, 834, 835, 836, 841, 842, 843, 844, 845, 846, 847, 848, 851, 855, 856, 857, 861, 862, 863, 865, 866, 867, 869, 871, 872, 873, 877, 878, 879];

    return mobileCodes.includes(code) || regionCodes.includes(code);
  }

  public static url(input: string): boolean {
    const pattern
      = /(ftp|http|https):\/\/(\w+:?\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
    return input ? pattern.test(input.trim()) : false;
  }

  public static inn(input: string): boolean {
    const pattern = /^\d{10}$|^\d{12}$/i;

    return input ? pattern.test(input.trim()) : false;
  }

  public static company(input: string): boolean {
    // eslint-disable-next-line no-useless-escape
    const pattern = /^(?!.*[}{:,\[\]"]).{0,50}$/;
    return pattern.test(input.trim());
  }

  public static fio(input: string): boolean {
    // eslint-disable-next-line no-useless-escape
    const pattern = /^(?!.*[-' ]{2,})(?!.*[}{:,\[\]"])[A-Za-zА-Яа-яЁё](?:[A-Za-zА-Яа-яЁё](?![-' ]{2})|[-' ]){0,48}[A-Za-zА-Яа-яЁё]$/;
    return input ? pattern.test(input.trim()) : false;
  }

  public static noSpecialSymbols(input: string, forbidden?: string): boolean {
    if (!input) {
      return true;
    }

    const symbols = forbidden ?? DEFAULT_FORBIDDEN_SYMBOLS;
    const pattern = new RegExp(`[${symbols}]`);

    return !pattern.test(input);
  }
}
